module.exports = __webpack_public_path__ + "static/media/star-and-crescent.696ed775.svg";